export const SET_COLLECTION_V2_STATE = 'collectionV2/SET_COLLECTION_V2_STATE'
